import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Tooltip } from "antd";
import UserIcon from "../../../assets/images/user-icon.svg";
import leftArrow from "../../../assets/images/LeftArrow.svg";
import { toast } from "react-toastify";
import { useStore } from "../../../store";
import { useNavigate, useLocation } from "react-router-dom";
import { useTab } from "../../../custom-hooks/useTab";
import ImageLabel from "../../image-label";
import { useConnectsUForm } from "../../../custom-hooks/useConnectsUForm";
import { getFormFieldValue } from "../../../utils/index";
import { setUpdatedValues } from "../../../store/actions";
import { formatData } from "../../../utils/formatData";
import ModalMediaPlayer from "../../videoPlayer/modalPlayer";
import QuestionIcon from "../../../assets/images/question-icon.svg";
import { endUserAssetTypeOptions, orgAdminAssetTypeOptions, partnerAdminAssetTypeOptions } from "./HelpConstants";

const { TextArea } = Input;

export default function EditHelp() {
  const navigate = useNavigate();
  const { state } = useLocation() || {};
  const [mediatype] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const whichTab = "help";
  const { updateImage } = useConnectsUForm();
  const { updatedValues, dispatch } = useStore();
  const [formChanged, setFormChanged] = useState(false);
  const tabData = state?.helpData ? [state?.helpData] : [];
  const { callMicroServices } = useTab();
  const [userRole, setUserRole] = useState();
  const helpRows = Form.useWatch("help", form);

  useEffect(() => {
    setUserRole(state?.userRole);
  }, [state?.userRole]);

  useEffect(() => {
    dispatch(setUpdatedValues({}));
    setFormChanged(false);
  }, [dispatch]);

  useEffect(() => {
    setFormChanged(Object.keys(updatedValues).length > 0);
  }, [updatedValues]);

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  const findValue = (i, key) => {
    const row = helpRows?.[i];
    if (key === "url") {
      return row?.mediaLink?.url ?? getFormFieldValue(form, "help", i, key);
    }
    if (key === "type") {
      return row?.mediaLink?.mediaType ?? getFormFieldValue(form, "help", i, key);
    }
    if (key === "blob") {
      return row?.blob ?? getFormFieldValue(form, "help", i, key);
    }
    return getFormFieldValue(form, "help", i, key);
  };

  const SelectChangeHandler = (mediaType, i) => {
    form.setFieldValue([whichTab, i, "blob"], undefined);
    form.setFieldValue([whichTab, i, "mediaLink"], {
      mediaType,
    });

    const prevItems = updatedValues.help || [];
    dispatch(
      setUpdatedValues({
        ...updatedValues,
        help: [...new Set([...prevItems, i])],
      })
    );
    setFormChanged(true);
  };

  const fieldsChange = (changedFields) => {
    const userTouched = (changedFields || []).filter((field) => field?.touched);
    if (!userTouched.length) {
      return;
    }

    const next = { ...updatedValues };

    userTouched.forEach((field) => {
      const getNames = field.name;
      if (!getNames?.length) {
        return;
      }

      const nameModified =
        getNames[0] === "corousel" ? "corousel" : getNames[0];
      const rowIndex = getNames[1];
      const prevItems = next[nameModified] || [];

      next[nameModified] = [...new Set([...prevItems, rowIndex])];
    });

    dispatch(setUpdatedValues(next));
    setFormChanged(true);
  };

  const handleUpdateItem = async (data) => {
    console.log("onfinish data", data["help"]);

    let existingData = [],
      newData = [];
    if (data["help"]) {
      data["help"].forEach((item) => {
        if (item.id) {
          existingData.push(item);
        } else {
          newData.push(item);
        }
      });
      if (userRole) {
        // console.log("updated", updatedValues)
        const formattedData = formatData(
          "help",
          data["help"],
          updatedValues,
          userRole
        );
        console.log("formatted", formattedData);
        if (Object.keys(formattedData).length > 0) {
          dispatch(setUpdatedValues({}));
          const response = await callMicroServices("help", formattedData, form);
          if (response) {
            setFormChanged(false);
            navigate("/admin", { state: { reload: true } });
          }
          // setTimeout(() => {
          //   getHelpInfo();
          // }, 2000);
        } else {
          toast.error("Nothing to update");
        }
      }
    }
  };

  return (
    <div>
      <div
        className="heading-backBtn"
        onClick={() => {
          navigate("/admin", { state: { reload: false } });
          sessionStorage.removeItem("helpDataResponse");
        }}
      >
        <img style={{ marginRight: "8px" }} src={leftArrow} alt="leftarrow" />
        Edit Help
      </div>

      <div className="multipalFormStyle">
        <Form
          name="control-hooks"
          className="organizationForm"
          form={form}
          autoComplete="off"
          labelCol={{ span: 5 }}
          onFinish={handleUpdateItem}
          onFieldsChange={fieldsChange}
        >
          <div className="multipalFormRow">
            <div className="multipalFormCol">
              <Form.List name="help" initialValue={tabData}>
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }, i) => (
                      <div className="formListRow">
                        <div className="formListCol">

                          <Form.Item
                            {...restField}
                            className="edit-videos-title"
                            label="Title"
                            name={[name, "title"]}
                            rules={[
                              {
                                required: true,
                                message: "title is required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Title"
                              maxLength={30}
                              showCount
                            />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            className="edit-videos-title"
                            label="Description"
                            name={[name, "description"]}
                            rules={[
                              {
                                required: true,
                                message: "Description is required",
                              },
                              {
                                validator: (_, value) => {
                                  if (value && value.length > 400) {
                                    return Promise.reject(
                                      new Error("Description cannot exceed 400 characters")
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <TextArea
                              placeholder="Description"
                              rows={3}
                              maxLength={400}
                              showCount
                            />
                          </Form.Item>

                          <div className="d-flex">
                            <Form.Item
                              {...restField}
                              name={[name, "mediaLink", "mediaType"]}
                              className="edit-videos-title"
                              label="Image/Video"
                              style={{ minWidth: "100%", display: "block" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Select any option",
                                },
                              ]}
                            >
                              <Select
                                name={[name, "mediaLink", "mediaType"]}
                                onChange={(e) => {
                                  SelectChangeHandler(e, i);
                                }}
                                placeholder="Select Option"
                              >
                                <Select.Option value="VIMEO_MEDIA">
                                  Add Vimeo Link
                                </Select.Option>
                                <Select.Option value="SOCIAL_MEDIA">
                                  Add Youtube Link
                                </Select.Option>
                                <Select.Option value="SYNTHESIA_MEDIA">Add Synthesia Link</Select.Option>
                                <Select.Option value="IMAGE">
                                  Upload Image
                                </Select.Option>
                              </Select>
                            </Form.Item>
                            <Form.Item style={{ marginLeft: "5px" }}>
                              <div className="edit-remove-btn">
                                <Tooltip
                                  title={
                                    "Upload Video link or image with size lesser than 2.5MB"
                                  }
                                >
                                  <img
                                    src={QuestionIcon}
                                    alt="question-icon"
                                  />
                                </Tooltip>
                              </div>
                            </Form.Item>
                          </div>

                          {findValue(i, "type") === "SOCIAL_MEDIA" ? (
                            <Form.Item
                              key={`youtube-${name}`}
                              label="Youtube Link"
                              {...restField}
                              name={[name, "mediaLink", "url"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Youtube link is required",
                                },
                              ]}
                            >
                              <Input placeholder="Youtube Link" />
                            </Form.Item>
                          ) : findValue(i, "type") === "VIMEO_MEDIA" ? (
                            <Form.Item
                              key={`vimeo-${name}`}
                              label="Vimeo Link"
                              {...restField}
                              name={[name, "mediaLink", "url"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Vimeo link is required",
                                },
                              ]}
                            >
                              <Input placeholder="Vimeo Link" />
                            </Form.Item>
                          ) : findValue(i, "type") === "IMAGE" ? (
                            <Form.Item
                              {...restField}
                              label={<ImageLabel label={"Image"} />}
                              colon={false}
                              name="mediaLink"
                              className="experienceImg"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    return findValue(i, "blob")
                                      ? Promise.resolve()
                                      : findValue(i, "url")
                                        ? Promise.resolve()
                                        : Promise.reject(
                                          new Error("Image is required")
                                        );
                                  },
                                },
                              ]}
                            >
                              {findValue(i, "blob") ? (
                                <img
                                  src={URL.createObjectURL(
                                    findValue(i, "blob")
                                  )}
                                  style={{
                                    maxHeight: "120px",
                                    width: "300px",
                                    border: "1px solid #A5A5A5",
                                    borderRadius: "5px",
                                    objectFit: "contain",
                                    marginBottom: "-10px",
                                    marginRight: "10px",
                                  }}
                                  alt=""
                                />
                              ) : findValue(i, "url") ? (
                                <img
                                  src={findValue(i, "url")}
                                  alt=""
                                  style={{
                                    maxHeight: "120px",
                                    width: "300px",
                                    border: "1px solid #A5A5A5",
                                    borderRadius: "5px",
                                    objectFit: "contain",
                                    marginBottom: "-10px",
                                    marginRight: "10px",
                                  }}
                                />
                              ) : (
                                <img
                                  src={UserIcon}
                                  alt=""
                                  style={{
                                    maxHeight: "80px",
                                    marginRight: "10px",
                                    marginBottom: "-15px",
                                  }}
                                />
                              )}

                              <label
                                name="file"
                                className="fileUploadBtn redBtn"
                                style={{ padding: "8px" }}
                              >
                                {" "}
                                Upload Image
                                <input
                                  accept="image/png, image/gif, image/jpeg"
                                  type="file"
                                  style={{ display: "none" }}
                                  // required={true}
                                  onChange={(e) =>
                                    updateImage(e, i, form, whichTab)
                                  }
                                />
                              </label>
                              <Tooltip
                                className="question"
                                title={
                                  "Upload only .PNG, .JPG or .JPEG images and File size shouldn't exceed 2MB. Recommended image dimensions: 1280x720 pixels"
                                }
                              >
                                <img
                                  src={QuestionIcon}
                                  alt="question-icon"
                                />
                              </Tooltip>
                            </Form.Item>
                          ) : findValue(i, "type") === "SYNTHESIA_MEDIA" ? (
                            <Form.Item
                              key={`synthesia-${name}`}
                              label="Synthesia Link"
                              labelCol={{ span: 5 }}
                              {...restField}
                              name={[name, "mediaLink", "url"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Synthesia  link is required",
                                },

                              ]}
                            >
                              <Input />
                            </Form.Item>
                          ) : null}
                          <Form.Item
                            {...restField}
                            className="edit-videos-title"
                            label={<span style={{ marginLeft: "0px" }}>Web Link</span>}
                            name={[name, "webLink"]}
                            rules={[
                              {
                                required: false,
                                message: "Web link is required",
                              },
                              {
                                validator: (_, value) => {
                                  if (!value) return Promise.resolve();

                                  // Generic URL regex
                                  const urlRegex =
                                    /^(https?:\/\/)([\w-]+\.)+[\w-]{2,}(\/\S*)?$/;

                                  return urlRegex.test(value)
                                    ? Promise.resolve()
                                    : Promise.reject(new Error("Enter a valid web link"));
                                },
                              },
                            ]}
                          >
                            <Input placeholder="Web link"
                              onChange={(e) => {
                                const value = e.target.value;

                                if (value.length > 200) {
                                  toast.warn("Weblink should not exceed 200 characters");

                                  form.setFieldValue(
                                    [whichTab, name, "webLink"],
                                    value.slice(0, 200)
                                  );
                                }
                              }}
                            />
                          </Form.Item>
                          <div className="d-flex">
                            {userRole === "ORGANIZATION_ADMIN" ? (
                              <Form.Item
                                {...restField}
                                className="edit-videos-title"
                                style={{
                                  minWidth: "100%",
                                  display: "block",
                                }}
                                label="Asset Type"
                                name={[name, "assetTypeEnum"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Select one asset typefrom list",
                                  },
                                ]}
                              >
                                <Select
                                  name={[name, "assetTypeEnum"]}
                                  placeholder="Select subject type"
                                >
                                  {orgAdminAssetTypeOptions?.map(({ value, label }) => (
                                    <Select.Option key={value} value={value}>
                                      {label}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            ) : userRole === "PARTNER_ADMIN" ? (
                              <Form.Item
                                {...restField}
                                className="edit-videos-title"
                                style={{
                                  minWidth: "100%",
                                  display: "block",
                                }}
                                label="Asset Type"
                                name={[name, "assetTypeEnum"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Select one asset typefrom list",
                                  },
                                ]}
                              >
                                <Select
                                  name={[name, "assetTypeEnum"]}
                                  placeholder="Select subject type"
                                >
                                  {partnerAdminAssetTypeOptions?.map(({ value, label }) => (
                                    <Select.Option key={value} value={value}>
                                      {label}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            ) : userRole === "END_USER" ? (
                              <Form.Item
                                {...restField}
                                className="edit-videos-title"
                                style={{
                                  minWidth: "100%",
                                  display: "block",
                                }}
                                label="Asset Type"
                                name={[name, "assetTypeEnum"]}
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "Select one asset typefrom list",
                                  },
                                ]}
                              >
                                <Select
                                  name={[name, "assetTypeEnum"]}
                                  placeholder="Select subject type"
                                >
                                  {endUserAssetTypeOptions?.map(({ value, label }) => (
                                    <Select.Option key={value} value={value}>
                                      {label}
                                    </Select.Option>
                                  ))}


                                </Select>
                              </Form.Item>
                            ) : null}

                            <Form.Item style={{ marginLeft: "5px" }}>
                              <div className="edit-remove-btn">
                                <Tooltip
                                  title={
                                    "For which section this help content needs to be displayed"
                                  }
                                >
                                  <img
                                    src={QuestionIcon}
                                    alt="question-icon"
                                  />
                                </Tooltip>
                              </div>
                            </Form.Item>
                          </div>


                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, curValues) => {
                              const prevType =
                                prevValues?.help?.[name]?.assetTypeEnum;
                              const curType =
                                curValues?.help?.[name]?.assetTypeEnum;
                              return prevType !== curType;
                            }}
                          >
                            {({ getFieldValue }) =>
                              getFieldValue(["help", name, "assetTypeEnum"]) ===
                                "OTHER" ? (
                                <Form.Item
                                  {...restField}
                                  className="edit-videos-title-subject-type hide-label"
                                  label=" "
                                  labelCol={{ span: 5 }}
                                  wrapperCol={{ span: 19 }}
                                  name={[name, "assetTypeName"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter a value for Other",
                                    },
                                    {
                                      validator: (_, value) => {
                                        if (value && value.length > 30) {
                                          return Promise.reject(
                                            new Error("Cannot exceed 30 characters")
                                          );
                                        }
                                        return Promise.resolve();
                                      },
                                    },
                                  ]}
                                >
                                  <Input
                                    className="subject-type-input"
                                    placeholder="Enter subject type"
                                    maxLength={30}
                                    showCount
                                  />
                                </Form.Item>
                              ) : null
                            }
                          </Form.Item>{" "}
                        </div>
                      </div>
                    ))}

                    <div className="formListRow">
                      <div className="formListCol">
                        <div className="inputBody">
                          <label></label>
                          <div style={{ textAlign: "right" }}>
                            {formChanged ? (
                              <Button
                                className="saveBtn redBtn"
                                style={{ margin: "20px 10px" }}
                                onClick={() => {
                                  form.submit();
                                }}
                              >
                                Save
                              </Button>
                            ) : (
                              <Button
                                className="saveBtn redBtn"
                                style={{
                                  opacity: "0.5",
                                  pointerEvents: "none",
                                  margin: "0 10px",
                                }}
                              >
                                Save
                              </Button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </Form.List>

            </div>
          </div>
        </Form>
      </div>
      {isModalOpen ? (
        <ModalMediaPlayer
          closeModal={handleCancel}
          mediaLink={videoUrl}
          mediaType={mediatype}
        />
      ) : (
        ""
      )}
    </div>
  );
}
